<script setup>
import { computed, ref } from "vue";
import { Phone } from "@lucide/vue";

const props = defineProps({
  modelValue: { type: String, default: "" },
  required: Boolean,
  placeholder: { type: String, default: "05xx xxx xx xx" },
});
const emit = defineEmits(["update:modelValue", "validity"]);
const touched = ref(false);

function digits(value) {
  let result = String(value || "").replace(/\D/g, "");
  if (result.startsWith("90") && result.length > 10) result = `0${result.slice(2)}`;
  if (result.startsWith("5")) result = `0${result}`;
  if (result && !result.startsWith("0")) return "";
  if (result.length > 1 && !result.startsWith("05")) return "0";
  return result.slice(0, 11);
}
function format(value) {
  const valueDigits = digits(value);
  return [
    valueDigits.slice(0, 4),
    valueDigits.slice(4, 7),
    valueDigits.slice(7, 9),
    valueDigits.slice(9, 11),
  ].filter(Boolean).join(" ");
}
const formatted = computed(() => format(props.modelValue));
const isValid = computed(() => {
  const valueDigits = digits(props.modelValue);
  return valueDigits ? /^05\d{9}$/.test(valueDigits) : !props.required;
});
const showError = computed(() => touched.value && !isValid.value);

function update(event) {
  const next = format(event.target.value);
  emit("update:modelValue", next);
  event.target.value = next;
  emit("validity", /^05\d{9}$/.test(digits(next)) || (!next && !props.required));
}
function blur() {
  touched.value = true;
  emit("validity", isValid.value);
}
</script>

<template>
  <div>
    <div class="relative">
      <Phone class="pointer-events-none absolute left-3 top-3 size-4 text-slate-400" />
      <input
        type="tel"
        inputmode="numeric"
        autocomplete="tel"
        maxlength="14"
        :required="required"
        :pattern="required || modelValue ? '05[0-9]{2} [0-9]{3} [0-9]{2} [0-9]{2}' : undefined"
        :value="formatted"
        :placeholder="placeholder"
        :aria-invalid="showError"
        :class="['input pl-9 font-medium tabular-nums', showError && 'border-red-400 focus:border-red-500 focus:ring-red-500/10']"
        @input="update"
        @blur="blur"
      />
    </div>
    <p v-if="showError" class="mt-1.5 text-xs font-medium text-red-600">Telefon numarası 05xx xxx xx xx biçiminde olmalıdır.</p>
  </div>
</template>

